var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.galleryVersion === "modern"
    ? _c(
        "div",
        {
          staticClass: "gallery-autoplay-toggle",
          class: {
            "gallery-autoplay-toggle--modern": _vm.galleryVersion == "modern",
          },
          on: {
            click: function ($event) {
              return _vm.toggleAutoplay()
            },
          },
        },
        [
          _c("label", {
            staticClass: "gallery-autoplay-toggle__label",
            attrs: { id: "autoplayCheckboxLabel", for: "autoplayCheckbox" },
            domProps: {
              innerHTML: _vm._s(
                _vm.labels ? _vm.labels.autoplayFilterLabel : null
              ),
            },
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "gallery-autoplay-toggle__button",
            class: _vm.autoplay ? "toggle-on" : "toggle-off",
            attrs: {
              type: "checkbox",
              "aria-labelledby": "autoplayCheckboxLabel",
              id: "autoplayCheckbox",
              role: "checkbox",
              "aria-checked": _vm.autoplay,
              tabindex: "0",
            },
            domProps: { checked: _vm.autoplay },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "checkmark" }),
        ]
      )
    : _vm.galleryVersion === "legacy"
    ? _c("div", { staticClass: "gallery-autoplay-toggle" }, [
        _c("label", {
          staticClass: "gallery-autoplay-toggle__label",
          attrs: { id: "autoplayCheckboxLabel", for: "autoplayCheckbox" },
          domProps: {
            innerHTML: _vm._s(
              _vm.labels ? _vm.labels.autoplayFilterLabel : null
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "gallery-autoplay-toggle__button",
            class: _vm.autoplay ? "toggle-on" : "toggle-off",
            attrs: {
              "aria-labelledby": "autoplayCheckboxLabel",
              id: "autoplayCheckbox",
              role: "checkbox",
              "aria-checked": _vm.autoplay ? "true" : "false",
              tabindex: "0",
            },
            on: {
              click: function ($event) {
                return _vm.toggleAutoplay()
              },
              keydown: _vm.onSwitchKeyDown,
            },
          },
          [
            _c("span", { staticClass: "switch" }, [
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.autoplay,
                    expression: "autoplay",
                  },
                ],
                staticClass: "on",
                attrs: { "aria-hidden": "true" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.labels ? _vm.labels.autoplayFilterOnText : null
                  ),
                },
              }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.autoplay == false,
                    expression: "autoplay == false",
                  },
                ],
                staticClass: "off",
                attrs: { "aria-hidden": "true" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.labels ? _vm.labels.autoplayFilterOffText : null
                  ),
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "switch-slide" }),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }